<template>
  <div class="column full-height">
    <p class="full-width text-center q-mt-sm q-mb-lg">
      {{ body }}
    </p>
    <div class="row justify-center items-center q-mt-sm" v-if="supportNumber">
      <QIcon :name="icon" size="32px" color="primary" class="q-mr-sm" />
      <SAILink
        :label="supportNumber"
        :href="`tel:${supportNumber}`"
        class="text-weight-bold text-h4"
      />
    </div>
  </div>
</template>

<script>
import { QIcon } from 'quasar';
import SAILink from '../../atom/sai-link';

export default {
  name: 'SaiUserProfileStepContactUs',
  props: {
    body: {
      type: String,
      default:
        'We need to identify your employer to provide you with our best rates and an accurate quote. Please call us below to verify your employer.'
    },
    icon: {
      type: String,
      default: 'eva-phone-outline'
    },
    supportNumber: String
  },
  components: {
    QIcon,
    SAILink
  }
};
</script>
